export interface Services {
  image: string
  title: string
  description: string
}

export const SERVICES = [
  {
    title:
      '8万点の豊富なラインナップ',
    image: 'service_1',
    description:
      '現場・工場、医療・介護、飲食、カジュアル・オフィスなど様々な業種向けの商品を取り揃えております。'
  },
  {
    title:
      '絞り込み検索で探しやすさアップ',
    image: 'service_2',
    description:
      '業種・カテゴリ・印刷加工・機能など、お探しの商品を様々な角度から検索することができます。'
  },
  {
    title:
      '購入前に仕上がりイメージが見れる',
    image: 'service_3',
    description:
      'プレビュー画面で仕上がりイメージを見ることができます。色々なデザインを試したり、比較・検討にご活用ください。'
  },
  {
    title: '名入れ加工100円〜',
    image: 'service_4',
    description: '店舗名やロゴなどの刺繍・プリントが1箇所100円から可能。1枚からお気軽にオリジナルユニフォームを作成できます。'
  },
  {
    title: '全国送料無料でお届け',
    image: 'service_5',
    description: '登録した画像は保存され、次回以降もデザインシミュレータやご注文時にお使いいただけます'
  },
  {
    title: 'お支払い方法は3種類',
    image: 'service_6',
    description: 'お支払い方法は、請求書払い、クレジットカード払い、コンビニ支払いの3種類よりお選びいただけます。'
  }
]
